import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=ae6ca9fa&scoped=true&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"
import style0 from "./comments.vue?vue&type=style&index=0&id=ae6ca9fa&lang=scss&scoped=true&"
import style1 from "./comments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6ca9fa",
  null
  
)

export default component.exports